var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#ECEDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.99958C18 7.44758 17.5522 6.99979 17.0002 6.99979H13.8436C13.6333 6.99979 13.4406 6.88105 13.3459 6.69221L13.1539 6.30758C13.0592 6.11874 12.8665 6 12.6562 6H11.3438C11.1328 6 10.9402 6.11874 10.8461 6.30758L10.6541 6.69221C10.5594 6.88105 10.3667 6.99979 10.1558 6.99979H6.99979C6.44716 6.99979 6 7.44758 6 7.99958",
    stroke: "black",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52344 9.5V16.4682C7.52344 17.4307 8.32491 18.2107 9.31333 18.2107H14.683C15.6721 18.2107 16.4729 17.4307 16.4729 16.4682V9.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55859 12.5V16.5004",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5022V11.0547",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4414 16.5004V12.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6fbec415992814ba5f134e405dd8bc65.svg";
export { ForwardRef as ReactComponent };